// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__JOhI9","left":"InfoRow_left__1sW9o"};